import React from "react";
import { Button } from "antd";
import { useSelector } from "react-redux";
import { translate } from "$ACTIONS/Translate";

function PromotionStatusButton({
    selectedPromotionItem,
    selectedPromotionDetail,
    applyManualPromotion,
    applyBonusPromotion,
    showAppliedHistory,
    onBonusClaim,
    OnCompleteRefresh,
    tabKey, /// 1 -> selectedPromotionDetail 2 -> selectedPromotionItem
}) {
    const { selectedBonus } = useSelector((state) => state.promotion);
    let thisHistory;

    if (tabKey === 1 && selectedPromotionDetail?.history) {
        thisHistory = selectedPromotionDetail.history; // Use selectedPromotionDetail history first if index is 1
    } else if (selectedPromotionDetail?.history) {
        thisHistory = selectedPromotionDetail.history; // Detail自帶history的優先，因為promotionlist獲取的history可能範圍過大，會拿到比較舊的數據
    } else if (selectedPromotionItem?.history) {
        thisHistory = selectedPromotionItem.history; // Detail沒有自帶history才嘗試從promotionlist獲取
    }

    console.log("selectedPromotionItem",     
        selectedPromotionItem,
        selectedPromotionDetail);
        console.log("thisHoistory", thisHistory);
        console.log("tabKey", tabKey);

    return (
        <>
            {selectedPromotionDetail &&
                (() => {
                    // Handle the history cases first
                    if (thisHistory) {
                        switch (thisHistory.status) {
                            case "Processing":
                                return (
                                    <Button onClick={showAppliedHistory}>
                                        {translate("查看已提交资料")}
                                    </Button>
                                );
                            case "Serving":
                                if(thisHistory?.progress !== "-") {
                                return (
                                    <div className="rate-viewer-box">
                                        <div className="rate-base">
                                            <div
                                                style={{
                                                    width: `${(thisHistory?.percentage / 100) * 600}px`,
                                                }}
                                                className="percentage"
                                            >
                                                <div className="indicator"></div>
                                            </div>
                                        </div>
                                        <div className="scale-box">
                                            {["0%", "50%", "100%"].map((position) => (
                                                <div className="scale-text-box" key={position}>
                                                    <div className="scale-line">
                                                        <p>{position}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <p>{`${translate("还需流水")} ${thisHistory?.turnoverNeeded}, ${translate("可以获得红利")} ${thisHistory?.bonusAmount} đ`}</p>
                                    </div>
                                );}
                                break;
                            case "Release":
                                return (
                                    thisHistory.isClaimable && (
                                        <Button
                                            className="btn-get-bonus"
                                            onClick={() => {
                                                console.log("btn-get-bonus",selectedPromotionDetail, selectedPromotionItem)
                                                const playerBonusId = (tabKey === 1 && selectedPromotionDetail?.history?.playerBonusId) 
                                                    || selectedPromotionItem?.playerBonusId 
                                                    || selectedPromotionDetail?.history?.playerBonusId;
                                                console.log("playerBonusId", playerBonusId);
                                                if (onBonusClaim) {
                                                    onBonusClaim(playerBonusId);
                                                    OnCompleteRefresh();
                                                }
                                            }}
                                        >
                                            {translate("立即获得奖励")}
                                        </Button>
                                    )
                                );
                            case "Waiting for release":
                                return <Button disabled>{translate("待派发")}</Button>;
                            case "Served":
                            case "Force to served":
                                return <Button disabled>{translate("已领取")}</Button>;
                            case "Pending":
                                return <Button disabled style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "8px",
                                }}>{translate("待处理2")}</Button>;
                            default:
                                return null;
                        }
                    }

                    // If no valid history status, handle Bonus or Manual promotion cases
                    if (
                        (selectedBonus || selectedPromotionDetail.promoType === "Manual") &&
                        (!thisHistory || !["Serving", "Release", "Force to served", "Waiting for release"].includes(thisHistory?.status))
                    ) {
                        if (selectedPromotionDetail.actionType === "NO_ACTION") {
                            return null;
                        }

                        switch (selectedPromotionDetail.promoType) {
                            case "Manual":
                                if (
                                    selectedPromotionDetail.isExpired ||
                                    selectedPromotionDetail.isNotStart ||
                                    !selectedPromotionDetail.isInApplicationDuration
                                ) {
                                    return (
                                        <Button disabled>
                                            {translate("仅限指定时间内适用")}
                                        </Button>
                                    );
                                } else {
                                    switch (selectedPromotionDetail.actionType) {
                                        case "APPLY_FORM":
                                            return (
                                                <Button onClick={applyManualPromotion}>
                                                    {translate("立即领取")}
                                                </Button>
                                            );
                                        case "LIVECHAT":
                                            return (
                                                <Button onClick={() => global.PopUpLiveChat()}>
                                                    {translate("在线客服")}
                                                </Button>
                                            );
                                        default:
                                            return null;
                                    }
                                }
                            case "Bonus":
                                return (
                                    <Button onClick={applyBonusPromotion}>
                                        {translate("获得奖励")}
                                    </Button>
                                );
                            default:
                                return null;
                        }
                    }

                    return null;
                })()}
        </>
    );
}

export default PromotionStatusButton;
